import { useEffect, useRef, useState } from "react";

/** Runs a promise and exposes data/loading/error plus reload(). Stale answers (from a load a
 * newer one superseded) are dropped; old data stays on screen while a reload is in flight. */
export function useLoad<T>(fn: () => Promise<T>, deps: readonly unknown[]) {
  const [state, setState] = useState<{ data?: T; loading: boolean; error?: Error }>({ loading: true });
  const generation = useRef(0);
  const key = JSON.stringify(deps);

  const reload = () => {
    const mine = ++generation.current;
    setState((s) => ({ data: s.data, loading: true }));
    fn().then(
      (data) => {
        if (generation.current === mine) setState({ data, loading: false });
      },
      (error) => {
        if (generation.current === mine) setState({ loading: false, error: error as Error });
      },
    );
  };

  useEffect(() => {
    // Deferred so the effect itself never sets state synchronously.
    queueMicrotask(reload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return { ...state, reload };
}
